export const CONFIG_PULLED = 'CONFIG_PULLED';
export const ADD_BADGES = 'ADD_BADGES';
export const REMOTE_CONFIG = 'REMOTE_CONFIG';
